exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.jc-cell-list {\n  background: #fff;\n}\n.jc-cell-list .jc-cell-wrapper {\n    padding: 0 2.66667vw;\n}\n", "", {"version":3,"sources":["F:/develop/JCeshop-wx/src/components/cell/list.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;CAClB;AACD;IACI,qBAAqB;CACxB","file":"list.vue","sourcesContent":["\n.jc-cell-list {\n  background: #fff;\n}\n.jc-cell-list .jc-cell-wrapper {\n    padding: 0 2.66667vw;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?{"sourceMap":true}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a2d60e84","scoped":false,"hasInlineConfig":false}!./node_modules/_sass-loader@7.1.0@sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/components/cell/list.vue
// module id = mwpy
// module chunks = 83